import Layout from '@/layout'

const hospitalManage = {
    path: '/financial',
    component: Layout,
    children: [
        {
            // 订单列表
            path: '/financial/orderList',
            name: 'orderList',
            component: () => import('@/views/doctor/financial/orderList'),
            meta: { activeMenu: '/financial/orderList' }
        },
        {
            // 订单详情
            path: '/financial/orderDetail/:orderId/:activeName',
            name: 'orderDetail',
            component: () => import('@/views/doctor/financial/orderDetail'),
            meta: { activeMenu: '/financial/orderList' }
        },
        {
            // 提现列表
            path: '/financial/withdrawList',
            name: 'withdrawList',
            component: () => import('@/views/doctor/financial/withdrawList'),
            meta: { activeMenu: '/financial/withdrawList' }
        }
    ]
}

export default hospitalManage
